//import { IDimension } from "models/dashboard/core";
import { IDashboardSharedViewModel } from "models/common";
import { KeyedDimension } from "models/common/plotdata/viewModel";
import { IDimension, IStringDate } from "models/core";

/**
 * Valid values for age range
 */
export const ageRanges = {
    lt19: { key: "15-18", name: "15-18" } as KeyedDimension,
    lt26: { key: "19-25", name: "19-25" } as KeyedDimension,
    ltother: { key: "Other", name: "Other" } as KeyedDimension,
    unknown: { key: "Unk", name: "Unk" } as KeyedDimension,
}

/**
 * Keys for Y/N fields
 */
export const boolOptions = {
    y: { key: "Yes", name: "Yes" } as KeyedDimension,
    n: { key: "No", name: "No" } as KeyedDimension,
    unknown: { key: "Unk", name: "Unk" } as KeyedDimension,
}

export interface IDashboardViewModel extends IDashboardSharedViewModel {
	diagnosisDate: IStringDate,
	primarySite: IDimension,
	reportingPrimarySite: IDimension,
	morphology: IDimension,
	dataQualityEligible: boolean,
	youthHadTreatment: KeyedDimension,
    fertilityPreservationId: IDimension,
    diagnosisRecurrenceId: IDimension, 
    youthHasGpDetails: KeyedDimension,
    psychosocialCarePlanNum: number,
    receivedPsychosocialCareNum: number,
    hadFertilityDiscussionNum: number,
    referralToFertilitySpecialistNum: number,
    fertilityPreservationNum: number,
    reviewedAtTreatmentMDTNum: number,
    psychosocialSurvivorshipCarePlanNum: number,
    medicalTreatmentPlanToGPNum: number,
    enrolledInMedicalTrialNum: number,
    enrolledInOtherResearchNum: number,
    oneYearSurvivalNum: number, 
    oneYearSurvivalDen: number,
    twoYearSurvivalNum: number, 
    twoYearSurvivalDen: number,
    fiveYearSurvivalNum: number, 
    fiveYearSurvivalDen: number

}